<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">{{ this.$route.name }}</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active"><i v-bind:class="routeIcon"></i> {{ $t(this.$route.name) }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <AddForm  ref="addModal" :default-values="{}" @finish="handleItemsUpdate"/>
      <WazdanFreespinsImportForm  ref="importModal"/>
      <div class="container-fluid">
        <b-row class="col-lg-12">
          <div class="col-lg-12">
            <b-button type="button" variant="success" class="mb-1 mr-1" @click="$refs.addModal.showModal()">
              <i class="fas fa-plus"></i> Add
            </b-button>

            <input ref="importFile" v-on:change="importCSV" name="file" type="file" accept=".csv" style="display: none">
            <b-button type="button" variant="default" class="mb-1 mr-1" @click="$refs.importFile.click()">
              <i class="fas fa-upload"></i> Import csv
            </b-button>

            <a href="/wazdan_freespins_import_template.csv" target="_blank"><small><i class="fas fa-download"></i> template.csv</small></a>

          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div class="col-lg-3 col-md-3 col-sm-12" v-for="({id, type, label, options, loaded, internalSearch, searchChange}) in filterInputs" v-bind:key="id">
            <b-form-group label-cols-lg="4" :label-for="id + '-filter-input'" :label="label" v-if="type === 'input'">
              <b-form-input :id="id + '-filter-input'" v-model="filters[id]" autocomplete="off" :placeholder="'Enter ' + label"/>
            </b-form-group>

            <b-form-group label-cols-lg="4" :label-for="id + '-filter-input'" :label="label" v-if="type === 'multiselect'">
              <multiselect v-model="filters[id]"
                           :disabled="!loaded"
                           :loading="!loaded"
                           :options="options"
                           label="label"
                           track-by="value"
                           :multiple="false"
                           :placeholder="'Select ' + label"
                           :internal-search="internalSearch"
                           @search-change="searchChange"
              />
            </b-form-group>
          </div>
        </b-row>

        <b-row class="col-lg-12">
          <div class="col-lg-12 col-md-12 col-sm-12 apply-clear">
            <FilterButtons
                :cancel="this.cancel"
                :loadFn="loadItems"
                :cancelFn="cancelRequest"
                :resetFn="clearFilters"
                :loadButtonDisabled="!(this.filters.operatorId && this.playerIds.length)"
            />
          </div>
        </b-row>

        <div class="row col-12" id="loading-container">
          <div class="col-12 mb-10">
            <div class="mb-10">
              <div class="table-wrapper mb-10">
                <b-table
                    striped small hover show-empty no-local-sorting sort-icon-left
                    :busy="!!cancel" :items="filteredItems" :empty-text="emptyText" :fields="fields"
                >
                  <template #cell(count-ratio-stake)="{item}">
                    {{ item.count }} / {{ item.ratio }} / {{ item.stake }}
                  </template>
                  <template #cell(actions)="{item}">
                    <span>
                    <b-button type="button" variant="success" class="mr-1 btn-xs" @click="$refs.addModal.showModal(item)">
                      <i class="fas fa-copy"></i> Copy
                    </b-button>
                    </span>
                    <ShowForm :defaultValues="item"/>
                    <RemoveForm v-if="item.state === 'active' && new Date(item.startDate + ' UTC') > new Date()" :object="item.id"
                                message="Please confirm removing freespins with id "
                                :remove-handler="(modal) => {handleFreespinsRemove(modal, item)}"
                    ></RemoveForm>
                  </template>
                </b-table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
.table td {
  min-width: 50px !important;
}
</style>
<script>
import axios from "axios";
import {getRouteIcon, ROUTE_WAZDAN_FREESPINS} from "../../utils/routerIcons";
import FilterButtons from "../../components/FilterButtons";
import WazdanFreespinsAddForm from "../../components/WazdanFreespins/WazdanFreespinsAddForm";
import WazdanFreespinsShowForm from "../../components/WazdanFreespins/WazdanFreespinsShowForm";
import WazdanFreespinsImportForm from "../../components/WazdanFreespins/WazdanFreespinsImportForm";
import Multiselect from "vue-multiselect";
import RemoveForm from "../../components/remove-form/RemoveForm.vue";

function getDefaultSort() {
  return {
    column: 'username',
    order: 'ASC',
  };
}

function getDefaultFilters() {
  return {
    operatorId: null,
    playerIds: null,
    status: null
  };
}

export default {
  components: {
    AddForm: WazdanFreespinsAddForm,
    ShowForm: WazdanFreespinsShowForm,
    WazdanFreespinsImportForm,
    RemoveForm,
    FilterButtons,
    Multiselect
  },
  data() {
    return {
      operatorOptions: [],
      filters: getDefaultFilters(),
      cancel: null,
      error: null,
      fields: [
        { key: 'id', label: 'ID', },
        { key: 'state', label: 'State', },
        // { key: 'meta', label: 'Meta', },
        // { key: 'addDate', label: 'Add Date', },
        { key: 'startDate', label: 'Start Date', },
        { key: 'endDate', label: 'End Date', },
        { key: 'type', label: 'Type', },
        { key: 'currency', label: 'Currency', },
        // { key: 'count', label: 'Count', },
        { key: 'count', label: 'Count' },
        { key: 'ratio', label: 'Ratio' },
        { key: 'stake', label: 'Stake' },
        { key: 'value', label: 'Value' },
        // { key: 'campaignId', label: 'Campaign ID', },
        // { key: 'txId', label: 'Tx ID', },
        { key: 'tableId', label: 'Table ID', },
        // { key: 'skinId', label: 'Skin ID', },
        { key: 'playerId', label: 'Player ID', },
        // { key: 'ratio', label: 'Ratio', },
        // { key: 'stake', label: 'Stake', },
        { key: 'actions', label: 'Actions' }
      ],
      items: [],
      sorts: getDefaultSort(),
    }
  },
  computed: {
    filteredItems() {
      let items = this.items;
      if (this.filters.status && this.filters.status.value) {
        items = this.items.filter((item) => item.state === this.filters.status.value)
      }
      return items;
    },
    filterInputs() {
      return [
        {id: 'operatorId', type: 'multiselect', label: 'Operator', options: this.operatorOptions, internalSearch: true, loaded: this.$store.getters['operatorsForSelect/loaded'], searchChange: () => {}},
        {id: 'playerIds', type: 'input', label: 'Player IDs', placeholder: 'Separate by comma'},
        {id: 'status', type: 'multiselect', label: 'Status', options: ['active', 'finished', 'finishedNoPrize', 'canceled', 'deleted'].map((item) => {return {value: item, label: item}}), internalSearch: true, loaded: true, searchChange: () => {}},
      ];
    },
    emptyText() {
      if (this.cancel) {
        return 'Loading items..';
      }

      if (this.error?.response?.data?.message) {
        return this.error?.response?.data?.message;
      }

      if (this.error) {
        return this.error.message;
      }

      return 'There are no records to show';
    },
    routeIcon: () => getRouteIcon(ROUTE_WAZDAN_FREESPINS),
    playerIds() {
      return (this.filters.playerIds || '')
          .split(',')
          .map(playerId => playerId.trim())
          .filter(value => !!value)
    },
  },
  methods: {
    clearFilters() {
      this.filters = getDefaultFilters();
    },
    handleFreespinsRemove(modal, item) {
      this
        .$http({
          url: '/api/v1/wazdan-freespins/delete',
          method: 'POST',
          data: {
            operatorId: item.operatorId,
            playerId: item.playerId,
            txId: item.txId
          },
          headers: {'Content-Type': 'application/json'},
        })
        .then(() => {
          this.loadItems();
          modal.hideModal();
          this.$toastr.i('Success');
        })
        .catch((err) => {
          this.$toastr.e(JSON.stringify(err.response.data.message));

          throw err;
        });
    },
    handleItemsUpdate({secret, playerIds}) {
      this.filters.secret = secret;
      this.filters.playerIds = playerIds;

      this.loadItems();
    },
    loadItems() {
      this.items = [];

      let self = this;

      const operatorId = this.filters.operatorId ? this.filters.operatorId.value : null;
      this
          .$http({
            url: '/api/v1/wazdan-freespins',
            params: {
              ...this.filters,
              operatorId: operatorId,
              playerIds: this.playerIds.length ? this.playerIds : null,
            },
            method: 'GET',
            cancelToken: new axios.CancelToken(c => {self.cancel = c})
          })
          .then(resp => {
            let {items} = resp.data;
            this.items = items.sort((a, b) => a.id < b.id ? 1 : -1).map((item) => {
              let count = item.type === 'regular' ? item.count : null
              return {...item, operatorId, count}
            });
          })
          .catch((err) => {
            this.items = [];
            this.error = err;
          })
          .finally(() => {
            this.cancel = null;
          });
    },
    csvToArray(strData, strDelimiter = ",") {
      let objPattern = new RegExp(
        (
          "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
          "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
          "([^\"\\" + strDelimiter + "\\r\\n]*))"
        ),
        "gi"
      );

      let arrData = [[]];
      let arrMatches = objPattern.exec( strData );
      while (arrMatches) {
        let strMatchedDelimiter = arrMatches[ 1 ];
        if (
          strMatchedDelimiter.length &&
          (strMatchedDelimiter != strDelimiter)
        ){
          arrData.push( [] );
        }
        let strMatchedValue;

        if (arrMatches[ 2 ]){
          strMatchedValue = arrMatches[ 2 ].replace(
            new RegExp( "\"\"", "g" ),
            "\""
          );
        } else {
          strMatchedValue = arrMatches[ 3 ];
        }

        arrData[ arrData.length - 1 ].push( strMatchedValue );
        arrMatches = objPattern.exec( strData )
      }
      return( arrData );
    },
    importCSV() {
      const reader = new FileReader();

      reader.onload = (e) => {
        let importData = [];
        const text = e.target.result;
        const data = this.csvToArray(text, ";");
        const headers = data[0];
        console.log(data);
        for (let i in data) {
          if (i == 0) {
            continue;
          }

          let row = data[i];
          if (headers.length !== row.length) {
            continue;
          }

          let item = {
            id: i
          };
          row.forEach((col, index) => {
            let key = headers[index];
            item[key] = col;
          })

          importData.push(item)
        }

        this.$refs.importModal.showModal(importData);
        this.$refs.importFile.value = null;

      };

      reader.readAsText(this.$refs.importFile.files[0]);
    },
    cancelRequest() {
      if (this.cancel) {
        this.cancel('this -> cancel previous request');
      }
    },
  },
  mounted() {
  },
  async beforeMount() {
    await this.$store.dispatch('operatorsForSelect/loadList').then(() => {
      this.operatorOptions = this.$store.getters['operatorsForSelect/list'].map(({label, value}) => {return { label, value }});
    });
  },
}
</script>
